export default __webpack_public_path__ + "static/media/code.5c165046.png";